module.exports = __webpack_public_path__ + "img/link_acts_articles.d149a2a2.png";